import GroupRoute from './_config/portail.group.routes';
import groupList from './components/group-list';
import groupAdd from './components/group-add';

const moduleName = 'app.massia.common.portail.group';

angular.module(moduleName, []).config(GroupRoute).component('portailGroupList', groupList).component('portailGroupAdd', groupAdd);
export default moduleName;
